@if (isVisible()) {
  <div class="cart-block" data-testid="open-cart-button" (click)="openCart()">
    <div class="sm-block">
      <div class="cart-icon">
        <img class="icon-xl" [src]="'cart.svg' | themeSource" />
        <span>{{ quantity() }}</span>
      </div>
    </div>
    <h5>{{ 'CART.VIEW' | translate }}</h5>
    <span>{{ totalPrice() | currencySpace }}</span>
  </div>
}
